import dayjs from 'dayjs';
import { durationFormatter } from '../charts/helpers';
import Loading from '../charts/Loading';

interface Props {
  loading: boolean;
  reportTimeRange: number[];
  labels: string[];
}

// TODO(bobsin): this shouldn't rely on chart data
const TestPlan: React.FC<Props> = ({ loading, reportTimeRange, labels }) => {
  return (
    <div className="my-5 px-5 w-full text-lg text-gray-900">
      <header className="pl-3 font-semibold">Test Plan</header>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="mt-5 pl-3 pt-2 border-t-2 border-gray-100 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <div className="text-base font-medium">Start time</div>
            <div className="text-base sm:col-span-2">
              {reportTimeRange[0]
                ? dayjs
                    .unix(reportTimeRange[0])
                    .format('MMMM D YYYY, h:mm:ss a')
                : ''}
            </div>
          </div>
          <div className="pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <div className="text-base font-medium">End time</div>
            <div className="text-base sm:col-span-2">
              {reportTimeRange[0]
                ? dayjs
                    .unix(reportTimeRange[1])
                    .format('MMMM D YYYY, h:mm:ss a')
                : ''}
            </div>
          </div>
          <div className="pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <div className="text-base font-medium">Duration</div>
            <div className="text-base sm:col-span-2">
              {reportTimeRange.length > 0
                ? durationFormatter(reportTimeRange)
                : ''}
            </div>
          </div>
          <div className="pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <div className="text-base font-medium">Labels</div>
            <div className="text-base sm:col-span-2">
              {labels
                .filter((label) => label !== 'Overall')
                .map((label, i) => (
                  <div
                    key={i}
                    style={{ maxWidth: '300px' }}
                    className="inline-block mr-2 px-2 py-0.5 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium rounded-full text-summer-green-700 border-summer-green-200 bg-summer-green-100"
                  >
                    {label}
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TestPlan;
